import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import SoundCategory from '../../../domain/entities/SoundCategory';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexSoundCategoriesSuccess: {
      const result = action.payload as PaginatedResult<SoundCategory>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
